// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { SingleIconPieChart } from '@/components/composite/Charts/SingleIconPieChart';

export const genderDistributionConfig = {
    title: 'chart.tiktok.gender_distribution',
    name: {
        male: 'male',
        female: 'female',
        other: 'other',
        type: 'type',
        value: 'count',
        percentage_formatted: 'percentage'
    },
    id: 'gender_distribution',
    icon: 'followers',
    social: TIKTOK_BUSINESS,
    valueFormat: classicFormat,
    color: {
        male: 'purple',
        female: 'red',
        other: 'orange'
    },
    tooltip: 'chart.tiktok.gender_distribution_tooltip',
    size: SIZE_50,
    type: 'chart',
    element: SingleIconPieChart,
    tooltipTranslation: {
        token: 'chart.tiktok.gender_distribution_tooltip_translation',
        values: ['name', 'value', 'percentage']
    }
};
